import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "tbl-wrap" };
const _hoisted_2 = { class: "tbl tbl--border-bottom" };
import CartItem from "./CartItem.vue";
import CartEventBus from "../../CartEventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartTable',
    props: {
        initialized: Boolean,
        products: { type: Array },
    },
    setup(__props) {
        const props = __props;
        function enter(el, done) {
            if (!props.initialized) {
                done();
                return;
            }
            el.style.animation = 'highlight 1s ease-out forwards';
            el.addEventListener('animationend', () => {
                el.style.animation = '';
                done();
            }, { once: true });
        }
        function beforeLeave(el) {
            const maxHeight = `${el.scrollHeight}px`;
            if (window.innerWidth >= 1000) {
                el.querySelectorAll('td > *').forEach(el => el.style.maxHeight = maxHeight);
            }
            else {
                el.style.maxHeight = maxHeight;
            }
        }
        function leave(el) {
            if (window.innerWidth >= 1000) {
                el.querySelectorAll('td > *').forEach(el => el.style.maxHeight = '0');
            }
            else {
                el.style.maxHeight = '0';
            }
        }
        function afterLeave() {
            if (!props.products?.length) {
                CartEventBus.emit('cart:empty');
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "cart-head" }, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Товары")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Скидка")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Цена")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Кол‑во")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, "Сумма")
                            ]),
                            _createTextVNode(),
                            _createElementVNode("th", null, [
                                _createElementVNode("div", { class: "label" }, " ")
                            ])
                        ])
                    ], -1 /* CACHED */)),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("tbody", null, [
                        _createVNode(_TransitionGroup, {
                            name: "product",
                            onEnter: enter,
                            onBeforeLeave: beforeLeave,
                            onLeave: leave,
                            onAfterLeave: afterLeave
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
                                    return (_openBlock(), _createBlock(CartItem, {
                                        key: product.cartItemId,
                                        item: product,
                                        initialized: __props.initialized
                                    }, null, 8 /* PROPS */, ["item", "initialized"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]));
        };
    }
});
